const source = 'fattureClientiDataTable'

function getRiepilogo() {
  const keys = Object.keys(this.filtered.items).filter((s) => s == source)

  if(keys.length > 0){

    const items = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'fattura-riepilogo-ciclo-mesi',
      title: 'Riepilogo Ciclo Mesi',
      data: items,
      maximize: false,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': getRiepilogo,
}
